import { colors } from 'shared/styles/settings';
import styled from 'styled-components';
import { FormGroup } from 'shared/components/form/group';

export const Form = styled.form`
  height: 100%;
`;

export const Container = styled(FormGroup)`
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 2rem !important;

  @media only screen and (min-width: 600px) {
    padding: 3rem 4rem !important;
    width: 450px;
  }

  @media (min-width: 1280px) {
    padding: 2rem !important;
    width: 30%;
  }
`;

export const Title = styled.h1`
  color: ${colors.brown};
  font-size: 2rem;
  font-weight: bold;
  line-height: 2.25rem;
  margin-bottom: 3px;
`;
